var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderManagemenntNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_781_9815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9585 12.6714H7.97396L6.6311 5.95715H20.0596C20.1579 5.95752 20.2548 5.9794 20.3436 6.0213C20.4324 6.06319 20.511 6.12406 20.5737 6.19961C20.6365 6.27514 20.6819 6.36354 20.7068 6.45854C20.7316 6.55354 20.7354 6.65283 20.7176 6.74944L19.6165 12.1209C19.5908 12.2762 19.5103 12.4171 19.3895 12.5181C19.2688 12.6192 19.1159 12.6735 18.9585 12.6714Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.63107 5.95714L6.06707 3.80857C6.03611 3.65691 5.9537 3.5206 5.8338 3.42272C5.7139 3.32484 5.56386 3.27139 5.40907 3.27142H3.27393",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.97388 12.6714L8.53788 15.4914C8.56883 15.6431 8.65124 15.7794 8.77114 15.8773C8.89105 15.9752 9.0411 16.0286 9.19588 16.0286H17.3738",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7024 20.7285C16.3317 20.7285 16.031 20.4279 16.031 20.0571C16.031 19.6863 16.3317 19.3857 16.7024 19.3857C17.0733 19.3857 17.3739 19.6863 17.3739 20.0571C17.3739 20.4279 17.0733 20.7285 16.7024 20.7285Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9882 20.7285C9.61738 20.7285 9.31677 20.4279 9.31677 20.0571C9.31677 19.6863 9.61738 19.3857 9.9882 19.3857C10.359 19.3857 10.6596 19.6863 10.6596 20.0571C10.6596 20.4279 10.359 20.7285 9.9882 20.7285Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_781_9815"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderManagemenntNew);
export default __webpack_public_path__ + "static/media/OrderManagemenntNew.8c35184032aa4b7ed43bdba7b1693c5d.svg";
export { ForwardRef as ReactComponent };